<script setup lang="ts">
import JourneyExplorer from '@/dev-tools/JourneyExplorer.vue';
import DefaultLayout from './layouts/DefaultLayout.vue';
import { odsPopupContainer } from "omind-design-system/components/odsPopup"

</script>

<template>
    <DefaultLayout/>
    <odsPopupContainer />
    <div class="ods-tooltip-container"></div>
    <!-- <JourneyExplorer></JourneyExplorer> -->
</template>

<style>
.ods-tooltip-container{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
    z-index: 1000;
}



</style>
